import env from '../constants/auth.constants'

export type AppConfig = {
    buildEnvironment: string
    sso: {
        domain: string
        clientId: string
        customClaims: string
    }
    jarvisBaseUrl: string
    heimdallBaseUrl: string
    maestroBaseUrl: string
    editorConfig: {
        apiKey: string
    }
    segmentAPIKey: string
}

const buildEnvironment: string = process.env.ENV_BUILD_ENVIRONMENT!

export const appConfig: AppConfig = {
    buildEnvironment,
    sso: {
        domain: buildEnvironment == env.TESTING ? `$ENV_SSO_DOMAIN` : process.env.ENV_SSO_DOMAIN!,
        clientId: process.env.ENV_SSO_CLIENT_ID!,
        customClaims:
            buildEnvironment == env.TESTING
                ? `$ENV_SSO_CUSTOM_CLAIMS`
                : process.env.ENV_SSO_CUSTOM_CLAIMS!,
    },
    jarvisBaseUrl:
        buildEnvironment == env.TESTING ? `$ENV_JARVIS_BASE_URL` : process.env.ENV_JARVIS_BASE_URL!,
    heimdallBaseUrl:
        buildEnvironment == env.TESTING
            ? `$ENV_HEIMDALL_BASE_URL`
            : process.env.ENV_HEIMDALL_BASE_URL!,
    maestroBaseUrl:
        buildEnvironment == env.TESTING
            ? `$ENV_MAESTRO_BASE_URL`
            : process.env.ENV_MAESTRO_BASE_URL!,
    editorConfig: {
        apiKey: '',
    },
    segmentAPIKey:
        buildEnvironment == env.TESTING ? `$ENV_SEGMENT_API_KEY` : process.env.ENV_SEGMENT_API_KEY!,
}
